import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleComplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.25 3.75C7.69329 3.75 4 7.44329 4 12C4 16.5558 7.69335 20.25 12.25 20.25C16.8067 20.25 20.5 16.5558 20.5 12C20.5 7.44329 16.8067 3.75 12.25 3.75ZM2.5 12C2.5 6.61487 6.86487 2.25 12.25 2.25C17.6351 2.25 22 6.61487 22 12C22 17.3841 17.6352 21.75 12.25 21.75C6.86481 21.75 2.5 17.3841 2.5 12Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.2431 9.16108C16.5359 9.45397 16.5359 9.92884 16.2431 10.2217L11.6253 14.8395C11.3325 15.1323 10.8577 15.1324 10.5648 14.8396L8.25494 12.5307C7.96198 12.2379 7.96188 11.763 8.25471 11.4701C8.54755 11.1771 9.02242 11.177 9.31537 11.4698L11.0949 13.2486L15.1824 9.16108C15.4753 8.86818 15.9502 8.86818 16.2431 9.16108Z",
		fill: "currentColor"
	})]
});
export default SvgCircleComplete;
